import axios from 'axios';
import * as uConst from "../actions/userConst";
import imageOptimizer from "../../modules/imageOptimizer";
import cloneDeep from 'clone-deep';
import {BehaviorSubject} from 'rxjs'

const state = {
  usersApi: (process.env.VUE_APP_USTAGE_API || 'http://localhost:3000/api')+'/Users',
  loopbackApi: process.env.VUE_APP_USTAGE_API || 'http://localhost:3000/api',
  accessToken: localStorage.getItem('ustage-user-token') || '',
  status: {},
  userProfile: {},
  profileImg: '',
  RxIsLoadProfile: new BehaviorSubject(null)
}

// Без этого не работает... почему не знаю)
for(let x in uConst) {
  state.status[x] = false
}

const getters = {
  realEmail: state => {
    if(state.userProfile.email && !state.userProfile.isSocialRegister) {
      return state.userProfile.email
    } else {
      return state.userProfile.email2 || null
    }
  },
  RxIsLoadProfile: state => state.RxIsLoadProfile,
  isLogin: state => state.accessToken,
  isLoading: state => state.status[uConst.USER_REQUEST],
  isSearching: state => state.status[uConst.USER_SEARCH_REQUEST],
  isLoadingPosts: state => state.status[uConst.POSTS_REQUEST],
  isLoadingUser: state => state.status[uConst.USER_LOAD_REQUEST],
  isUserSending: state => state.status[uConst.USER_SEND_REQUEST],
  isUploadingImgGallery: state => state.status[uConst.USER_IMG_SEND_REQUEST],
  isUploadingVideoGallery: state => state.status[uConst.USER_GALLERY_VIDEO_SEND_REQUEST],
  isDeletingVideoGallery: state => state.status[uConst.VIDEO_DELETE_REQUEST],
  isDeletingImageGallery: state => state.status[uConst.IMAGE_DELETE_REQUEST],
  isSendingPost: state => state.status[uConst.POSTS_SEND_REQUEST],
  isUploadsRequest: state => state.status[uConst.UPLOADS_REQUEST],
  isAdmin: state => state.accessToken && state.userProfile && state.userProfile.stRoles && state.userProfile.stRoles.length && state.userProfile.stRoles[0]=='admin'?true:false,
  getUserProfile: state => state.userProfile,
  getAccessToken: state => state.accessToken,
  getProfileImg: state => state.profileImg,
}

const actions = {
  [uConst.SOCIAL_AUTH_REQUEST]: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      commit(uConst.AUTH_REQUEST)
      if(data) {
        localStorage.setItem('ustage-user-token', data)
        commit(uConst.AUTH_SUCCESS, data)
        resolve('set token - successfull')
      } else {
        commit(uConst.AUTH_ERROR)
        localStorage.removeItem('ustage-user-token')
        reject('token empty')
      }  
    })
  },
  [uConst.AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(uConst.AUTH_REQUEST)
      axios.defaults.params = {}
      axios.post(state.usersApi + '/login', user)
        .then(resp=>{
          localStorage.setItem('ustage-user-token', resp.data.id)
          commit(uConst.AUTH_SUCCESS, resp.data.id)
          dispatch(uConst.USER_REQUEST)
            .then((resp)=>resolve(resp))
            .catch((err)=>reject(err))
        })
        .catch(err=>{
          commit(uConst.AUTH_ERROR)
          localStorage.removeItem('ustage-user-token')
          reject(err)
        })
    })
  },
  [uConst.AUTH_LOGOUT]: ({commit}) => {
    const clearSession = () => {
      commit(uConst.AUTH_LOGOUT)
      localStorage.removeItem('ustage-user-token')
    }
    return axios.post(state.usersApi + '/logout').then(clearSession, clearSession)
  },
  [uConst.USER_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      if (state.accessToken) {
        commit(uConst.USER_REQUEST)
        axios.defaults.params = {};
        axios.defaults.params['access_token'] = state.accessToken
        axios.get(state.usersApi + '/me')
          .then(resp => {
            commit(uConst.USER_SET_PROFILE, resp.data)
          })
          .then(()=>{
            axios.get(state.usersApi + '/getProfileImages', {params: {id: state.userProfile.id}})
              .then((img)=> {
                commit(uConst.SET_PROFILE_IMAGE, img.data.image);
              });
          })
          .then(()=>{
            commit(uConst.USER_SUCCESS)
            resolve('User load from database')
          })
          .catch(() => {
            commit(uConst.USER_ERROR)
            dispatch(uConst.AUTH_LOGOUT)
            reject('invalid access token')
          })
      } else {
        reject('no find access token')
      }
    })
  },
  [uConst.USER_REGISTER]: ({commit,rootGetters}, {email, firstName, lastName, password, userType, userCategory, isAgreementAccepted, recaptchaToken}) => {
    return new Promise((resolve, reject) => {
      console.log(state.usersApi)
      commit(uConst.USER_REQUEST)
      const userData = Object.assign({}, {email: email, firstName: firstName, lastName: lastName, password: password, userType: userType, userCategory: userCategory, isAgreementAccepted: isAgreementAccepted, recaptchaToken: recaptchaToken});
      userData.locale = rootGetters.currentLng;
      axios.defaults.params = {}
      axios.post(state.usersApi, userData)
        .then(()=>{
          commit(uConst.USER_SUCCESS)
          resolve('User created')
        })
        .catch(err=>{
          commit(uConst.USER_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_RESET_EMAIL]: ({commit}, email) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_REQUEST)
      axios.post(state.usersApi+'/reset-email',{},  {params: {email: email}})
        .then(()=>{
          commit(uConst.USER_SUCCESS)
          resolve('Email send successfully')
        })
        .catch(err=>{
          commit(uConst.USER_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_CHANGE_PASSWORD]: ({commit}, {oldPassword, newPassword}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_REQUEST)
      axios.post(state.usersApi+'/change-password',{oldPassword: oldPassword, newPassword: newPassword})
        .then(()=>{
          commit(uConst.USER_SUCCESS)
          resolve('Password changed successfully')
        })
        .catch(err=>{
          commit(uConst.USER_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_RESET_PASSWORD]: ({commit}, {newPassword, accessToken}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_REQUEST)
      axios.defaults.params = {}
      axios.post(state.usersApi+'/reset-password',{newPassword: newPassword}, {params: {access_token: accessToken}})
        .then(()=>{
          commit(uConst.USER_SUCCESS)
          resolve('Password set successfully')
        })
        .catch(err=>{
          commit(uConst.USER_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_CONFIRM_EMAIL]: ({commit}, {uid, token}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_REQUEST)
      axios.defaults.params = {}
      // plugins.$delay(2000).then(()=>{}) // Задержка
      axios.get(state.usersApi+'/confirm',{params: {uid: uid, token: token}})
        .then(()=>{
          commit(uConst.USER_SUCCESS)
          resolve('Email confirm successfully')
        })
        .catch(err=>{
          commit(uConst.USER_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_LOAD]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_LOAD_REQUEST)
      axios.get(state.usersApi + '/me')
        .then((res)=>{
          commit(uConst.USER_LOAD_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.USER_LOAD_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_SEND_PATCH]: ({commit}, {id, data_change}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_SEND_REQUEST);
      axios.patch(state.usersApi + `/${id}`, data_change)
        .then((usr)=>{
          commit(uConst.USER_SEND_SUCCESS, usr.data)
          resolve('Update user successfully')
        })
        .catch(err=>{
          commit(uConst.USER_SEND_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_SEND]: ({commit}, post) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_SEND_REQUEST);
      // Удаление лишних полей перед отправкой
      let sendUser = cloneDeep(post.user)
      if(sendUser.propsList && sendUser.propsList.length) {
        sendUser.propsList.forEach(p=>{
          p.photos.forEach(ph=>{
            for (const key in ph) {
              if (key!=='photoId') {
                delete ph[key];
              }
            }
          })
        })
      }
      axios.put(state.usersApi + '/updateProfile', {updatedUser: sendUser})
        .then((res)=>{
          commit(uConst.USER_SEND_SUCCESS, sendUser)
          resolve('Update user successfully')
        })
        .catch(err=>{
          commit(uConst.USER_SEND_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_DELETE]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_DELETE_REQUEST)
      axios.put(state.usersApi + '/deleteProfile')
        .then(()=>{
          commit(uConst.USER_DELETE_SUCCESS)
          resolve('User was deleted successfully')
        })
        .catch(err=>{
          commit(uConst.USER_DELETE_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.IMAGE_DELETE]: ({commit}, image) => {
    return new Promise((resolve, reject) => {
      commit(uConst.IMAGE_DELETE_REQUEST)
      axios.put(state.loopbackApi + '/Uploads/deleteImage', {id: image.id})
        .then(()=>{
          commit(uConst.IMAGE_DELETE_SUCCESS)
          resolve('Image was deleted successfully')
        })
        .catch(err=>{
          commit(uConst.IMAGE_DELETE_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.VIDEO_DELETE]: ({commit}, video) => {
    return new Promise((resolve, reject) => {
      commit(uConst.VIDEO_DELETE_REQUEST)
      axios.put(state.loopbackApi + '/Uploads/deleteVideo', {id: video.id})
        .then(()=>{
          commit(uConst.VIDEO_DELETE_SUCCESS)
          resolve('Video was deleted successfully')
        })
        .catch(err=>{
          commit(uConst.VIDEO_DELETE_ERROR)
          reject(err)
        }
      )
    })
  },
  [uConst.USER_IMG_SEND]: ({commit}, img) => {
    // default values
    let maxResolution = 1920;
    let quality = 0.6;
    if (img.maxResolution && (typeof img.maxResolution !== 'undefined') && !isNaN(img.maxResolution)) {
      maxResolution = img.maxResolution;
    }
    if (img.quality && (typeof img.quality !== 'undefined') && !isNaN(img.quality)) {
      quality = img.quality;
    }
    return new Promise((resolve, reject) => {
      commit(uConst.USER_IMG_SEND_REQUEST);
      imageOptimizer(img.image, maxResolution, quality, (blob) => {
        if (!blob) {
          let err = { response: {
            data: {
              error: {
                code : 'FILE_FORMAT'
              }
            }
          }};
          commit(uConst.USER_IMG_SEND_ERROR)
          reject(err);
        } else {
          let formData = new FormData();
          formData.append('file', blob, blob.name);
          axios.post(state.loopbackApi + '/Uploads/upload?title='+ (typeof img.title === 'undefined' ? ' ' : img.title) +'&mediaType='+img.mediaType,
            formData,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
          ).then((res)=>{
            commit(uConst.USER_IMG_SEND_SUCCESS)
            resolve(res)
          }).catch(err=>{
            commit(uConst.USER_IMG_SEND_ERROR)
            reject(err)
          });
        }
      });
    });
  },
  [uConst.USER_GALLERY_VIDEO_LOAD]: ({commit}, get) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_GALLERY_VIDEO_LOAD_REQUEST)
      axios.get(state.loopbackApi + '/Uploads/getVideoList', {params: {id: get.id}})
        .then((res)=>{
          commit(uConst.USER_GALLERY_VIDEO_LOAD_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.USER_GALLERY_VIDEO_LOAD_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_GALLERY_IMAGES_LIST]: ({commit}, get) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_GALLERY_IMAGES_LIST_REQUEST)
      axios.get(state.loopbackApi + '/Uploads/getImagesList', {params: {id: get.id}})
        .then((res)=>{
          commit(uConst.USER_GALLERY_IMAGES_LIST_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.USER_GALLERY_IMAGES_LIST_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_GALLERY_IMAGE]: ({commit}, get) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_GALLERY_IMAGE_REQUEST)
      axios.get(state.loopbackApi + '/Uploads/getImageById', {params: {id: get.id}})
        .then((res)=>{
          commit(uConst.USER_GALLERY_IMAGE_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.USER_GALLERY_IMAGE_ERROR)
          reject(err)
        })
    })
  },
  [uConst.STATS_LOAD]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.STATS_LOAD_REQUEST)
      axios.get(state.loopbackApi + '/Users/stats')
        .then((res)=>{
          commit(uConst.STATS_LOAD_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.STATS_LOAD_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_GALLERY_VIDEO_SEND]: ({commit}, video) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_GALLERY_VIDEO_SEND_REQUEST);
      axios.post(state.loopbackApi + '/Uploads/uploadVideo?title='+video.title+'&poster='+video.poster+'&youtube='+video.youtube+'&vimeo='+video.vimeo+'&href='+video.href,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        }
      ).then((res)=>{
        commit(uConst.USER_GALLERY_VIDEO_SEND_SUCCESS)
        resolve(res)
      }).catch(err=>{
        commit(uConst.USER_GALLERY_VIDEO_SEND_ERROR)
        reject(err)
      });
    });
  },
  [uConst.USER_AVATAR_LOAD]: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_AVATAR_LOAD_REQUEST);
      axios.get(state.usersApi + '/getProfileImages', {params: {id: data.id}})
      .then((img)=>{
        commit(uConst.USER_AVATAR_LOAD_SUCCESS)
        resolve(img.data.image)
      })
      .catch(err=>{
        commit(uConst.USER_AVATAR_LOAD_ERROR)
        reject(err)
      });
    });
  },
  [uConst.USER_PROFILE_LOAD]: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_PROFILE_LOAD_REQUEST);
      axios.get(state.usersApi + '/userInfo', {params: {id: data.id || null}})
      .then((res)=>{
        commit(uConst.USER_PROFILE_LOAD_SUCCESS)
        resolve(res.data.user)
      })
      .catch(err=>{
        commit(uConst.USER_PROFILE_LOAD_ERROR)
        reject(err)
      });
    });
  },
  [uConst.POSTS_LOAD_IMAGE]: ({commit}, imageId) => {
    return new Promise((resolve, reject) => {
      // commit(uConst.POSTS_REQUEST)
      axios.get(state.loopbackApi + '/Uploads/getPostImage', {params: {id: imageId || ' '}})
        .then((result)=> {
          resolve(result.data.image);
        })
        .catch(err=>{
          // commit(uConst.POSTS_ERROR)
          reject(err)
        })
    })
  },
  [uConst.POSTS_LOAD_COUNT]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.POSTS_REQUEST)
      axios.get(state.loopbackApi+'/Posts/count', {params: {where: params.where}})
        .then(res=>{
          commit(uConst.POSTS_SUCCESS);
          resolve({allPostsCount: res.data.count});
        })
        .catch(err=>{
          commit(uConst.POSTS_ERROR)
          reject(err)
        })
    })
  },
  [uConst.POSTS_LOAD_BB]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.POSTS_REQUEST)
      let par = {
        filter: {
          order: 'created DESC', 
          include: {
            relation: 'users', 
            scope: {
              fields: ['id','firstName','lastName']
            }
          },
          where: params.where,
        }
      };
      if(params.skip) par.filter.skip = params.skip;
      if(params.limit) par.filter.limit = params.limit;
      axios.get(state.loopbackApi+'/Posts', { params: par })
      .then(res=>{
          commit(uConst.POSTS_SUCCESS);
          resolve({posts: res.data});
      })
      .catch(err=>{
        commit(uConst.POSTS_ERROR)
        reject(err)
      })
    })
  },
  [uConst.UPLOADS_LOAD_VIDEO]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.UPLOADS_REQUEST)
      let par = {
        filter: {
          order: 'dateCreating DESC', 
          // include: {
          //   relation: 'users', 
          //   scope: {
          //     fields: ['id','firstName','lastName']
          //   }
          // },
          where: {and: [{or: [{media: "youtube"}, {media: "vimeo"}]}]}
        }
      };
      if(params && params.where) par.filter.where.and.push(params.where);
      axios.get(state.loopbackApi+'/Uploads/count', {params: {where: par.filter.where}})
      .then(resAll=>{
        if(params && params.skip) par.filter.skip = params.skip;
        if(params && params.limit) par.filter.limit = params.limit;
        axios.get(state.loopbackApi+'/Uploads', { params: par })
        .then(res=>{
          commit(uConst.UPLOADS_SUCCESS);
          resolve({allVideosCount: resAll.data.count, videos: res.data});
        })
      })
      .catch(err=>{
        commit(uConst.UPLOADS_ERROR)
        reject(err)
      })
    })
  },
  [uConst.VIDEO_TREE_LOAD]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.VIDEO_TREE_REQUEST)
      axios.get(state.loopbackApi+'/video-trees')
      .then(res=>{
          commit(uConst.VIDEO_TREE_SUCCESS);
          resolve(res.data);
      })
      .catch(err=>{
        commit(uConst.VIDEO_TREE_ERROR)
        reject(err)
      })
    })
  },
  [uConst.UPLOADS_SAVE_HASH_TAG]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.UPLOADS_SAVE_HASH_TAG_REQUEST)
      axios.patch(state.loopbackApi+`/Uploads/${params.id}`, params.data)
      .then(res=>{
          commit(uConst.UPLOADS_SAVE_HASH_TAG_SUCCESS);
          resolve(res.data);
      })
      .catch(err=>{
        commit(uConst.UPLOADS_SAVE_HASH_TAG_ERROR)
        reject(err)
      })
    })
  },
  [uConst.POSTS_LOAD]: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit(uConst.POSTS_REQUEST)
      // {"include": {"relation": "users", "scope": {"fields": ["firstName","lastName"]}}}
      // console.log(state.loopbackApi);
      // console.log(params);
      axios.get(state.loopbackApi+'/Posts/count', {params: {where: params.where}})
        .then(resCountAll=>{
          axios.get(state.loopbackApi+'/Posts', {
            params: {
              filter: {
                order: 'created DESC', 
                include: {
                  relation: 'users', 
                  scope: {
                    fields: ['id','firstName','lastName']
                  }
                },
                where: params.where,
                skip: params.skip,
                limit: params.limit,
              }
            }
          })
          // axios.get(state.loopbackApi+'/Posts', {params: {filter: {order: 'created DESC', where: {usersId: state.userProfile.id}}}})
            // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 5000))) // Задержка ответа
            .then((res)=>{
              // Получаем количество "своих" постов
              let now = new Date()
              let now1 = new Date()
              now1.setDate(now1.getDate()+1)
              axios.get(state.loopbackApi+`/Users/${params.id}/posts/count`, {
                params: {
                  where: {created: {between: [now.toISOString().split('T')[0],now1.toISOString().split('T')[0]]}}
                }
              })
              .then((resC) => {
                let posts = res.data;
                let promiseArray = [];
                for (let i = 0, len = posts.length; i < len; i++) {
                    promiseArray.push(
                      axios.get(state.loopbackApi + '/Uploads/getPostImage', {params: {id: posts[i].imageId || ' '}})
                      .then((result)=> {
                        if (result.data.image.length > 10) {
                          posts[i].href = result.data.image;
                        }
                      })
                    );
                }
                if (promiseArray.length > 0) {
                  Promise.all(promiseArray)
                    .then(()=>{
                      commit(uConst.POSTS_SUCCESS);
                      resolve({posts: posts, myPostsCount: resC.data.count, allPostsCount: resCountAll.data.count});
                    })
                    .catch(err=>{
                      commit(uConst.POSTS_ERROR)
                      reject(err)
                    })
                } else {
                  commit(uConst.POSTS_SUCCESS);
                  resolve({posts: posts, myPostsCount: resC.data.count, allPostsCount: resCountAll.data.count});
                }
              })
            })
            .catch(err=>{
              commit(uConst.POSTS_ERROR)
              reject(err)
            })
          })
    })
  },
  [uConst.POST_DELETE]: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      commit(uConst.POSTS_REQUEST)
      axios.put(state.loopbackApi+'/Posts/deletePost', {postId: id})
        .then((res)=>{
          commit(uConst.POSTS_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.POSTS_ERROR)
          reject(err)
        })
    })
  },
  [uConst.USER_SEARCH]: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      commit(uConst.USER_SEARCH_REQUEST);
      axios.get(state.usersApi+'/search', 
      {
        params: {
          name: data.query[0] || '', 
          directory: !!data.directory,
          type: data.query[1] || '', 
          artistId: data.query[2] || '', 
          artistCategory: data.query[3] || '', 
          artistSkill: data.query[4] || '', 
          city: data.query[5] || '', 
          propsSizes: data.query[6],
          usersList: data.query[7],
          onlyWithPhoto: data.query[8],
          onlyWithVideo: data.query[9],
          userHeight: data.query[10] || '',
          skip: data.skip, limit: data.limit
        }
      })
      .then(res=>{
        commit(uConst.USER_SEARCH_SUCCESS)
        resolve(res.data)
      })
      .catch(err=>{
        commit(uConst.USER_SEARCH_ERROR)
        reject(err)
      });
    });
  },
  [uConst.POST_SEND]: ({commit}, {post, image}) => {
    return new Promise((resolve, reject) => {
      commit(uConst.POSTS_SEND_REQUEST)
      if (post.id) {
        axios.post(state.loopbackApi+'/Posts/updatePost', image,
        { headers: { 'Content-Type': 'multipart/form-data' }, params: {post: post} })
        .then(res=>{
          commit(uConst.POSTS_SEND_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.POSTS_SEND_ERROR)
          reject(err)
        })
      } else {
        axios.post(state.loopbackApi+'/Posts/addPost', image,
        { headers: { 'Content-Type': 'multipart/form-data' }, params: {post: post} })
        .then(res=>{
          commit(uConst.POSTS_SEND_SUCCESS)
          resolve(res.data)
        })
        .catch(err=>{
          commit(uConst.POSTS_SEND_ERROR)
          reject(err)
        })
      }
    })
  },
  // [uConst.POST_SEND]: ({commit}, post) => {
  //   return new Promise((resolve, reject) => {
  //     commit(uConst.POSTS_SEND_REQUEST)
  //     if(post.id) {
  //       axios.patch(state.loopbackApi+'/Posts/'+post.id, {participantType: post.participantType, googlePlace: post.googlePlace, date_start: post.date_start, date_end: post.date_end})
  //         .then(()=>{
  //           axios.put(state.loopbackApi+'/Posts/'+post.id+'/localeTexts/'+post.localeTexts[0].id, {text: post.localeTexts[0].text})
  //             .then(()=> {
  //               let promiseArray = []
  //               // Удаляем
  //               post.artistTypes.filter(f=>f.deleted).forEach(a=>promiseArray.push(
  //                 axios.delete(state.loopbackApi+'/Posts/'+post.id+'/artistTypes/'+a.id)
  //               ))
  //               // Добавляем
  //               post.artistTypes.filter(f=>!f.deleted && !f.id).forEach(a=>promiseArray.push(
  //                 axios.post(state.loopbackApi+'/Posts/'+post.id+'/artistTypes',
  //                   {artistTypeId: a.artistTypeId,
  //                     categories: a.categories,
  //                     skill: a.skill
  //                   })
  //               ))
  //               if(promiseArray.length) {
  //                 Promise.all(promiseArray)
  //                   .then(()=>{
  //                     commit(uConst.POSTS_SEND_SUCCESS)
  //                     resolve('Add post successfully')
  //                   })
  //                   .catch(err=>{
  //                     commit(uConst.POSTS_SEND_ERROR)
  //                     reject(err)
  //                   })
  //               } else {
  //                 commit(uConst.POSTS_SEND_SUCCESS)
  //                 resolve('Add post successfully')
  //               }
  //             })
  //             .catch(err=>{
  //               commit(uConst.USER_ERROR)
  //               reject(err)
  //             })
  //         })
  //         .catch(err=>{
  //           commit(uConst.USER_ERROR)
  //           reject(err)
  //         })
  //     } else {
  //       axios.post(state.loopbackApi+'/Posts',{usersId: post.usersId, participantType: post.participantType, googlePlace: post.googlePlace, date_start: post.date_start, date_end: post.date_end})
  //         .then((res)=>{
  //           let promiseArray = []
  //           post.localeTexts.forEach(t=>promiseArray.push(
  //             axios.post(state.loopbackApi+'/Posts/'+res.data.id+'/localeTexts', {locale: t.locale, text: t.text})
  //           ))
  //           post.artistTypes.forEach(a=>promiseArray.push(
  //             axios.post(state.loopbackApi+'/Posts/'+res.data.id+'/artistTypes',
  //               {artistTypeId: a.artistTypeId,
  //                 categories: a.categories,
  //                 skill: a.skill
  //               })
  //           ))
  //           if(promiseArray.length) {
  //             Promise.all(promiseArray)
  //               .then(()=>{
  //                 commit(uConst.POSTS_SEND_SUCCESS)
  //                 resolve('Add post successfully')
  //               })
  //               .catch(err=>{
  //                 commit(uConst.POSTS_SEND_ERROR)
  //                 reject(err)
  //               })
  //           } else {
  //             commit(uConst.POSTS_SEND_SUCCESS)
  //             resolve('Add post successfully')
  //           }
  //         })
  //         .catch(err=>{
  //             commit(uConst.USER_ERROR)
  //             reject(err)
  //           })
  //     }
  //   })
  // },
}

const mutations = {
  [uConst.SOCIAL_AUTH_REQUEST]: (state) => {
    state.status[uConst.AUTH_SUCCESS] = false
    state.status[uConst.AUTH_ERROR] = false
    state.status[uConst.SOCIAL_AUTH_REQUEST] = true
  },
  [uConst.AUTH_REQUEST]: (state) => {
    state.status[uConst.AUTH_SUCCESS] = false
    state.status[uConst.AUTH_ERROR] = false
    state.status[uConst.AUTH_REQUEST] = true
    state.status[uConst.SOCIAL_AUTH_REQUEST] = true
  },
  [uConst.AUTH_SUCCESS]: (state, resp) => {
    state.status[uConst.AUTH_REQUEST] = false
    state.status[uConst.SOCIAL_AUTH_REQUEST] = false
    state.status[uConst.AUTH_SUCCESS] = true
    state.accessToken = resp
  },
  [uConst.AUTH_ERROR]: (state) => {
    state.status[uConst.AUTH_REQUEST] = false
    state.status[uConst.SOCIAL_AUTH_REQUEST] = false
    state.status[uConst.AUTH_ERROR] = true
  },
  [uConst.AUTH_LOGOUT]: (state) => {
    state.accessToken = ''
    axios.defaults.params = {}
    state.userProfile = {}
  },
  [uConst.USER_REQUEST]: (state) => {
    state.status[uConst.USER_SUCCESS] = false
    state.status[uConst.USER_ERROR] = false
    state.status[uConst.USER_REQUEST] = true
  },
  [uConst.USER_SUCCESS]: (state) => {
    state.status[uConst.USER_REQUEST] = false
    state.status[uConst.USER_SUCCESS] = true
  },
  [uConst.USER_ERROR]: (state) => {
    state.status[uConst.USER_REQUEST] = false
    state.status[uConst.USER_ERROR] = true
  },
  [uConst.USER_SET_PROFILE]: (state, user) => {
    state.userProfile = user
    state.RxIsLoadProfile.next(state.userProfile)
  },
  [uConst.SET_PROFILE_IMAGE]: (state, img) => {
    state.profileImg = img
  },
  [uConst.POSTS_REQUEST]: (state) => {
    state.status[uConst.POSTS_SUCCESS] = false
    state.status[uConst.POSTS_ERROR] = false
    state.status[uConst.POSTS_REQUEST] = true
  },
  [uConst.POSTS_SUCCESS]: (state) => {
    state.status[uConst.POSTS_REQUEST] = false
    state.status[uConst.POSTS_SUCCESS] = true
  },
  [uConst.POSTS_ERROR]: (state) => {
    state.status[uConst.POSTS_REQUEST] = false
    state.status[uConst.POSTS_ERROR] = true
  },
  [uConst.UPLOADS_REQUEST]: (state) => {
    state.status[uConst.UPLOADS_SUCCESS] = false
    state.status[uConst.UPLOADS_ERROR] = false
    state.status[uConst.UPLOADS_REQUEST] = true
  },
  [uConst.UPLOADS_SUCCESS]: (state) => {
    state.status[uConst.UPLOADS_REQUEST] = false
    state.status[uConst.UPLOADS_SUCCESS] = true
  },
  [uConst.UPLOADS_ERROR]: (state) => {
    state.status[uConst.UPLOADS_REQUEST] = false
    state.status[uConst.UPLOADS_ERROR] = true
  },
  [uConst.UPLOADS_SAVE_HASH_TAG_REQUEST]: (state) => {
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_SUCCESS] = false
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_ERROR] = false
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_REQUEST] = true
  },
  [uConst.UPLOADS_SAVE_HASH_TAG_SUCCESS]: (state) => {
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_REQUEST] = false
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_SUCCESS] = true
  },
  [uConst.UPLOADS_SAVE_HASH_TAG_ERROR]: (state) => {
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_REQUEST] = false
    state.status[uConst.UPLOADS_SAVE_HASH_TAG_ERROR] = true
  },
  [uConst.VIDEO_TREE_REQUEST]: (state) => {
    state.status[uConst.VIDEO_TREE_SUCCESS] = false
    state.status[uConst.VIDEO_TREE_ERROR] = false
    state.status[uConst.VIDEO_TREE_REQUEST] = true
  },
  [uConst.VIDEO_TREE_SUCCESS]: (state) => {
    state.status[uConst.VIDEO_TREE_REQUEST] = false
    state.status[uConst.VIDEO_TREE_SUCCESS] = true
  },
  [uConst.VIDEO_TREE_ERROR]: (state) => {
    state.status[uConst.VIDEO_TREE_REQUEST] = false
    state.status[uConst.VIDEO_TREE_ERROR] = true
  },
  [uConst.USER_LOAD_REQUEST]: (state) => {
    state.status[uConst.USER_LOAD_SUCCESS] = false
    state.status[uConst.USER_LOAD_ERROR] = false
    state.status[uConst.USER_LOAD_REQUEST] = true
  },
  [uConst.USER_LOAD_SUCCESS]: (state) => {
    state.status[uConst.USER_LOAD_REQUEST] = false
    state.status[uConst.USER_LOAD_SUCCESS] = true
  },
  [uConst.USER_LOAD_ERROR]: (state) => {
    state.status[uConst.USER_LOAD_REQUEST] = false
    state.status[uConst.USER_LOAD_ERROR] = true
  },
  [uConst.USER_GALLERY_VIDEO_LOAD_REQUEST]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_SUCCESS] = false
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_ERROR] = false
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_REQUEST] = true
  },
  [uConst.USER_GALLERY_VIDEO_LOAD_SUCCESS]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_REQUEST] = false
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_SUCCESS] = true
  },
  [uConst.USER_GALLERY_VIDEO_LOAD_ERROR]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_REQUEST] = false
    state.status[uConst.USER_GALLERY_VIDEO_LOAD_ERROR] = true
  },
  [uConst.USER_GALLERY_IMAGES_LIST_REQUEST]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGES_LIST_SUCCESS] = false
    state.status[uConst.USER_GALLERY_IMAGES_LIST_ERROR] = false
    state.status[uConst.USER_GALLERY_IMAGES_LIST_REQUEST] = true
  },
  [uConst.USER_GALLERY_IMAGES_LIST_SUCCESS]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGES_LIST_REQUEST] = false
    state.status[uConst.USER_GALLERY_IMAGES_LIST_SUCCESS] = true
  },
  [uConst.USER_GALLERY_IMAGES_LIST_ERROR]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGES_LIST_REQUEST] = false
    state.status[uConst.USER_GALLERY_IMAGES_LIST_ERROR] = true
  },

  [uConst.USER_GALLERY_IMAGE_REQUEST]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGE_SUCCESS] = false
    state.status[uConst.USER_GALLERY_IMAGE_ERROR] = false
    state.status[uConst.USER_GALLERY_IMAGE_REQUEST] = true
  },
  [uConst.USER_GALLERY_IMAGE_SUCCESS]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGE_REQUEST] = false
    state.status[uConst.USER_GALLERY_IMAGE_SUCCESS] = true
  },
  [uConst.USER_GALLERY_IMAGE_ERROR]: (state) => {
    state.status[uConst.USER_GALLERY_IMAGE_REQUEST] = false
    state.status[uConst.USER_GALLERY_IMAGE_ERROR] = true
  },
  [uConst.STATS_LOAD_REQUEST]: (state) => {
    state.status[uConst.STATS_LOAD_SUCCESS] = false
    state.status[uConst.STATS_LOAD_ERROR] = false
    state.status[uConst.STATS_LOAD_REQUEST] = true
  },
  [uConst.STATS_LOAD_SUCCESS]: (state) => {
    state.status[uConst.STATS_LOAD_REQUEST] = false
    state.status[uConst.STATS_LOAD_SUCCESS] = true
  },
  [uConst.STATS_LOAD_ERROR]: (state) => {
    state.status[uConst.STATS_LOAD_REQUEST] = false
    state.status[uConst.STATS_LOAD_ERROR] = true
  },
  [uConst.USER_SEND_REQUEST]: (state) => {
    state.status[uConst.USER_SEND_SUCCESS] = false
    state.status[uConst.USER_SEND_ERROR] = false
    state.status[uConst.USER_SEND_REQUEST] = true
  },
  [uConst.USER_SEND_SUCCESS]: (state, user) => {
    state.status[uConst.USER_SEND_REQUEST] = false
    state.status[uConst.USER_SEND_SUCCESS] = true
    state.userProfile = user
  },
  [uConst.USER_SEND_ERROR]: (state) => {
    state.status[uConst.USER_SEND_REQUEST] = false
    state.status[uConst.USER_SEND_ERROR] = true
  },
  [uConst.USER_DELETE_REQUEST]: (state) => {
    state.status[uConst.USER_DELETE_SUCCESS] = false
    state.status[uConst.USER_DELETE_ERROR] = false
    state.status[uConst.USER_DELETE_REQUEST] = true
  },
  [uConst.USER_DELETE_SUCCESS]: (state) => {
    state.status[uConst.USER_DELETE_REQUEST] = false
    state.status[uConst.USER_DELETE_SUCCESS] = true
  },
  [uConst.USER_DELETE_ERROR]: (state) => {
    state.status[uConst.USER_DELETE_REQUEST] = false
    state.status[uConst.USER_DELETE_ERROR] = true
  },
  [uConst.IMAGE_DELETE_REQUEST]: (state) => {
    state.status[uConst.IMAGE_DELETE_SUCCESS] = false
    state.status[uConst.IMAGE_DELETE_ERROR] = false
    state.status[uConst.IMAGE_DELETE_REQUEST] = true
  },
  [uConst.IMAGE_DELETE_SUCCESS]: (state) => {
    state.status[uConst.IMAGE_DELETE_REQUEST] = false
    state.status[uConst.IMAGE_DELETE_SUCCESS] = true
  },
  [uConst.IMAGE_DELETE_ERROR]: (state) => {
    state.status[uConst.IMAGE_DELETE_REQUEST] = false
    state.status[uConst.IMAGE_DELETE_ERROR] = true
  },
  [uConst.VIDEO_DELETE_REQUEST]: (state) => {
    state.status[uConst.VIDEO_DELETE_SUCCESS] = false
    state.status[uConst.VIDEO_DELETE_ERROR] = false
    state.status[uConst.VIDEO_DELETE_REQUEST] = true
  },
  [uConst.VIDEO_DELETE_SUCCESS]: (state) => {
    state.status[uConst.VIDEO_DELETE_REQUEST] = false
    state.status[uConst.VIDEO_DELETE_SUCCESS] = true
  },
  [uConst.VIDEO_DELETE_ERROR]: (state) => {
    state.status[uConst.VIDEO_DELETE_REQUEST] = false
    state.status[uConst.VIDEO_DELETE_ERROR] = true
  },
  [uConst.USER_IMG_SEND_REQUEST]: (state) => {
    state.status[uConst.USER_IMG_SEND_SUCCESS] = false
    state.status[uConst.USER_IMG_SEND_ERROR] = false
    state.status[uConst.USER_IMG_SEND_REQUEST] = true
  },
  [uConst.USER_IMG_SEND_SUCCESS]: (state) => {
    state.status[uConst.USER_IMG_SEND_REQUEST] = false
    state.status[uConst.USER_IMG_SEND_SUCCESS] = true
  },
  [uConst.USER_IMG_SEND_ERROR]: (state) => {
    state.status[uConst.USER_IMG_SEND_REQUEST] = false
    state.status[uConst.USER_IMG_SEND_ERROR] = true
  },
  [uConst.USER_GALLERY_VIDEO_SEND_REQUEST]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_SEND_SUCCESS] = false
    state.status[uConst.USER_GALLERY_VIDEO_SEND_ERROR] = false
    state.status[uConst.USER_GALLERY_VIDEO_SEND_REQUEST] = true
  },
  [uConst.USER_GALLERY_VIDEO_SEND_SUCCESS]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_SEND_REQUEST] = false
    state.status[uConst.USER_GALLERY_VIDEO_SEND_SUCCESS] = true
  },
  [uConst.USER_GALLERY_VIDEO_SEND_ERROR]: (state) => {
    state.status[uConst.USER_GALLERY_VIDEO_SEND_REQUEST] = false
    state.status[uConst.USER_GALLERY_VIDEO_SEND_ERROR] = true
  },
  [uConst.USER_AVATAR_LOAD_REQUEST]: (state) => {
    state.status[uConst.USER_AVATAR_LOAD_SUCCESS] = false
    state.status[uConst.USER_AVATAR_LOAD_ERROR] = false
    state.status[uConst.USER_AVATAR_LOAD_REQUEST] = true
  },
  [uConst.USER_AVATAR_LOAD_SUCCESS]: (state) => {
    state.status[uConst.USER_AVATAR_LOAD_REQUEST] = false
    state.status[uConst.USER_AVATAR_LOAD_SUCCESS] = true
  },
  [uConst.USER_AVATAR_LOAD_ERROR]: (state) => {
    state.status[uConst.USER_AVATAR_LOAD_REQUEST] = false
    state.status[uConst.USER_AVATAR_LOAD_ERROR] = true
  },
  [uConst.USER_PROFILE_LOAD_REQUEST]: (state) => {
    state.status[uConst.USER_PROFILE_LOAD_SUCCESS] = false
    state.status[uConst.USER_PROFILE_LOAD_ERROR] = false
    state.status[uConst.USER_PROFILE_LOAD_REQUEST] = true
  },
  [uConst.USER_PROFILE_LOAD_SUCCESS]: (state) => {
    state.status[uConst.USER_PROFILE_LOAD_REQUEST] = false
    state.status[uConst.USER_PROFILE_LOAD_SUCCESS] = true
  },
  [uConst.USER_PROFILE_LOAD_ERROR]: (state) => {
    state.status[uConst.USER_PROFILE_LOAD_REQUEST] = false
    state.status[uConst.USER_PROFILE_LOAD_ERROR] = true
  },
  [uConst.POSTS_SEND_REQUEST]: (state) => {
    state.status[uConst.POSTS_SEND_SUCCESS] = false
    state.status[uConst.POSTS_SEND_ERROR] = false
    state.status[uConst.POSTS_SEND_REQUEST] = true
  },
  [uConst.POSTS_SEND_SUCCESS]: (state) => {
    state.status[uConst.POSTS_SEND_REQUEST] = false
    state.status[uConst.POSTS_SEND_SUCCESS] = true
  },
  [uConst.POSTS_SEND_ERROR]: (state) => {
    state.status[uConst.POSTS_SEND_REQUEST] = false
    state.status[uConst.POSTS_SEND_ERROR] = true
  },
  [uConst.USER_SEARCH_REQUEST]: (state) => {
    state.status[uConst.USER_SEARCH_SUCCESS] = false
    state.status[uConst.USER_SEARCH_ERROR] = false
    state.status[uConst.USER_SEARCH_REQUEST] = true
  },
  [uConst.USER_SEARCH_SUCCESS]: (state) => {
    state.status[uConst.USER_SEARCH_REQUEST] = false
    state.status[uConst.USER_SEARCH_SUCCESS] = true
  },
  [uConst.USER_SEARCH_ERROR]: (state) => {
    state.status[uConst.USER_SEARCH_REQUEST] = false
    state.status[uConst.USER_SEARCH_ERROR] = true
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
